export default __webpack_public_path__ + "afc0a32b60ea7138f3af5d6a46693977.svg";